import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const initialState = {
	maps: JSON.parse(localStorage.getItem("maps")),
	allMaps: !!localStorage.getItem("allMaps"),
	actions: JSON.parse(localStorage.getItem("actions")) || [],
};

export const useCanvasStore = create(
	devtools(
		persist(
			(set, get) => ({
				...initialState,
				setAllMaps: (maps) => {
					set({ maps, allMaps: true });
				},
				clearAllMaps: () => {
					set({ maps: null, allMaps: false });
				},
				addToMaps: (map) => {
					set((state) => ({ maps: [...(state.maps || []), map] }));
				},
				setActions: (actions) => {
					set({ actions });
				},
			}),
			{
				name: "canvas-storage",
			}
		)
	)
);
